import type { BestTimeDef } from '@/lib/best-time-pages';
import { ui, uiFb } from '@/lib/i18n';

interface MonthGuideGridProps {
  months: BestTimeDef['months'];
  bestMonths: number[];
  lang: string;
}

export function MonthGuideGrid({ months, bestMonths, lang }: MonthGuideGridProps) {
  return (
    <div className="mb-8 border-t border-border-subtle pt-6">
      <h2 className="font-heading text-xl font-bold text-text-primary md:text-2xl">
        {uiFb('ui.month_by_month_guide', 'Month-by-Month Guide', lang)}
      </h2>
      <div className="mt-4 grid grid-cols-2 gap-3 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6">
        {months.map(m => {
          const isPeak = bestMonths.includes(m.month);
          return (
            <div
              key={m.month}
              className={`rounded-lg border p-3 ${
                isPeak
                  ? 'border-accent-primary/30 bg-accent-primary/5'
                  : 'border-border-subtle bg-surface-card'
              }`}
            >
              <div className="flex items-center justify-between">
                <span className="text-xs font-semibold text-text-primary">
                  {ui('month_' + m.month, lang)}
                </span>
                {isPeak && (
                  <span className="rounded bg-accent-primary/20 px-1 py-0.5 text-caption font-medium text-accent-primary">
                    {uiFb('ui.peak', 'Peak', lang)}
                  </span>
                )}
              </div>
              <span className="mt-0.5 inline-block rounded bg-surface-root px-1.5 py-0.5 text-caption text-text-secondary">
                {m.season}
              </span>
              <p className="mt-1.5 text-label leading-snug text-text-secondary">{m.highlight}</p>
            </div>
          );
        })}
      </div>
    </div>
  );
}
